var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorplanline1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 417,
    viewBox: "0 0 535 417",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.821777 692.944V488.473C0.821777 463.035 21.4263 442.413 46.8433 442.413H459.393C484.81 442.413 505.415 421.792 505.415 396.354V107.334C505.415 81.8966 484.81 61.2752 459.393 61.2752H383.376C357.959 61.2752 337.354 40.6537 337.354 15.216V-106.101C337.354 -131.538 357.959 -152.16 383.376 -152.16H564.174",
    stroke: "url(#paint0_linear_9220_5053)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9220_5053",
    x1: 324.005,
    y1: 432.098,
    x2: -24.7528,
    y2: 581.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8F589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#27E8BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006C9F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorplanline1);
export default __webpack_public_path__ + "static/media/vectorplanline1.0cd4f21682a8249443d1d2d6b96b4937.svg";
export { ForwardRef as ReactComponent };